module.exports = __webpack_public_path__ + "img/404.c5b5eba7.jpg";